export default "__VITE_ASSET__271c3912__"